import { h, render, Component } from 'preact';
import TxrCookieBanner from './txr-cookie-banner';
class TxrFooter extends Component {
    state = {
        year: new Date().getFullYear()
    }
    render() {
        return (
            <footer class="txr-footer">
                <div class="footer-top">
                    <div class="footer-top-container">
                        <div class="top-logo-container">
                            <a class="logo-container__logo" href="/Home/Index">
                                <img alt="logo" src="/images/logo-whitegreen-esendex.svg" />
                            </a>
                            <div class="logo-container__text">
                                TEXT OR CALL US AT
                            </div>
                            <div class="logo-container__phone">
                                423-218-0111
                            </div>
                            <div class="logo-container__icons">
                                <a class="logo-container__icon-link" href="https://www.facebook.com/textrequest" target="_blank">
                                    <img class="icon-regular" alt="Facebook" src="/images/navigation/icon-facebook.svg" />
                                    <img class="icon-hover" alt="Facebook" src="/images/navigation/icon-facebook-hover.svg" />
                                </a>
                                <a class="logo-container__icon-link" href="https://www.instagram.com/text.request/" target="_blank">
                                    <img class="icon-regular" alt="Instagram" src="/images/navigation/icon-instagram.svg" />
                                    <img class="icon-hover" alt="Instagram" src="/images/navigation/icon-instagram-hover.svg" />
                                </a>
                                <a class="logo-container__icon-link" href="https://www.linkedin.com/company/text-request" target="_blank">
                                    <img class="icon-regular" alt="LinkedIn" src="/images/navigation/icon-linkedin.svg" />
                                    <img class="icon-hover" alt="LinkedIn" src="/images/navigation/icon-linkedin-on.svg" />
                                </a>
                            </div>
                        </div>
                        <div class="top-right-container">
                            <div class="top-main-container">
                                <div class="main-container__text">
                                    <div class="main-container__text-title">
                                        Instantly.
                                    </div>
                                    <div class="main-container__text-text">
                                    That’s how fast you’ll increase customer engagement.
                                    </div>
                                    <div class="main-container__text-hint">
                                        See firsthand how our text messaging software helps you connect with customers like never before.
                                    </div>
                                </div>
                                <div class="main-container__button">
                                    <a class="txr-button-link" href="/demo">
                                        <button class="txr-button txr-primary-button" type="button">
                                            <span class="txr-button__content">
                                                GET DEMO
                                                <i class="txr-button__angle-icon fal fa-angle-right"></i>
                                            </span>
                                        </button>
                                    </a>
                                </div>
                            </div>
                            <div class="top-menu-container">
                                <div class="top-menu__item">
                                    <div class="menu-item__title">
                                        Explore
                                    </div>
                                    <div class="menu-item__content">
                                        <a class="menu-item__link" href="/product/features">Features</a>
                                        <a class="menu-item__link" href="/integrations">Integrations</a>
                                        <a class="menu-item__link" href="/product/landline-texting">Landline Texting</a>
                                        <a class="menu-item__link" href="/solutions">Solutions</a>
                                    </div>
                                </div>
                                <div class="top-menu__item">
                                    <div class="menu-item__title">
                                        Support
                                    </div>
                                    <div class="menu-item__content">
                                        <a class="menu-item__link" href="/product/sms-api">API Docs</a>
                                        <a class="menu-item__link" href="https://help.textrequest.com" target="_blank">Help Center</a>
                                        <a class="menu-item__link" href="/resources/all">Resources</a>
                                        <a class="menu-item__link txr-cursor-pointer" id="txrManageCookie">Manage Cookies</a>
                                    </div>
                                </div>
                                <div class="top-menu__item">
                                    <div class="menu-item__title">
                                        Buy
                                    </div>
                                    <div class="menu-item__content">
                                        <a class="menu-item__link" href="/contact">Contact Us</a>
                                        <a class="menu-item__link" href="/partners">Partners</a>
                                        <a class="menu-item__link" href="/pricing">Pricing</a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer-bottom">
                    <div class="footer-bottom-container">
                        <div class="bottom-left">
                            <span class="footer-bottom__link">© {this.state.year} Text Request. All Rights Reserved.</span>
                        </div>
                        <div class="bottom-right">
                            <a class="footer-bottom__link" href="/news">News Room</a>
                            <a class="footer-bottom__link" href="/security">Security</a>
                            <a class="footer-bottom__link" href="/about">Our Story</a>
                            <a class="footer-bottom__link" href="/acceptable-use">Acceptable Use</a>
                            <a class="footer-bottom__link" href="/privacy-policy">Privacy</a>
                            <a class="footer-bottom__link" href="/cookie-policy">Cookies</a>
                            <a class="footer-bottom__link" href="/terms-of-service">Terms of Service</a>
                        </div>
                    </div>
                </div>
                <TxrCookieBanner triggerIds="txrManageCookie"></TxrCookieBanner>
            </footer>
            )
        }
    }
    
export default TxrFooter;